import counter from '../../utils/counter';

export const counterAd = counter();

export default counterAd;
